module.exports = __webpack_public_path__ + "static/img/t.a44a067.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/client/terminal-download/imgs/t.png
// module id = Gmvy
// module chunks = 2